import { ref, computed } from 'vue'
import { DEPARTMENT_TABS } from '../data/constants'

const activeDept = ref(0)
const activeReport = ref(-1) // -1 = overview

const isOverview = computed(() => activeReport.value === -1)
const currentDept = computed(() => DEPARTMENT_TABS[activeDept.value])
const currentReport = computed(() =>
  isOverview.value ? null : currentDept.value.reports[activeReport.value]
)

const reportContextKey = computed(() =>
  isOverview.value
    ? `${currentDept.value.id}::overview`
    : `${currentDept.value.id}::${currentReport.value.id}`
)

function switchDept(i) {
  activeDept.value = i
  activeReport.value = -1
}

function switchReport(i) {
  activeReport.value = i
}

function switchToOverview() {
  activeReport.value = -1
}

export function useActiveReport() {
  return {
    activeDept,
    activeReport,
    isOverview,
    currentDept,
    currentReport,
    reportContextKey,
    switchDept,
    switchReport,
    switchToOverview,
  }
}
